import { React, useState } from "react";
import searchstyles from "./searchComp.module.css";
import { FaMagnifyingGlass } from "react-icons/fa6";
import axios from "axios";
import defaultImage from "../../appImges/avatartTemplate/default_img.png";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../storage/UserContext";

const apiUrl = process.env.REACT_APP_URL;

const SearchComp = () => {
  /* SearchComp is a side component, used for quick access to the search feature of the website. The user can search for users, using their exact username (the search is case insensitive). If there is a result, the username and his / her profile image are displayed, and the result is linked to the profile page of the user. */

  const { userData } = useUser();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  // function to handle search
  const handleSearch = async () => {
    if (searchTerm.trim() === "") {
      return;
    }
    try {
      const response = await axios.get(
        `${apiUrl}/search/users/exact?search_query=${searchTerm}`,
        { withCredentials: true }
      );

      if (response.data.success) {
        if (response.data.user.length > 0) {
          setSearchResult(response.data.user[0]);
          setErrorMessage("");
        } else {
          setSearchResult(null);
          setErrorMessage("No user found.");
        }
      } else {
        setSearchResult(null);
        setErrorMessage("No user found.");
      }
    } catch (error) {
      setSearchResult(null);
      setErrorMessage("An error occurred while searching. Please try again.");
    }
  };

  /**
   * Handle change of the search query
   */
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setSearchResult(null);
      setErrorMessage("");
    }
  };

  /**
   * Visit the result user's profile page. If the found user is also the active user (the user searched for his / her own username), then the user will be redirected to the personal version of the profile page (not the public version), which has more information and features.
   */
  const handleLinkClick = (e) => {
    if (searchResult.username === userData.username) {
      // Reset the search term and results
      e.preventDefault();
      setSearchTerm("");
      setSearchResult(null);
      setErrorMessage("");
      // Redirect to the logged-in user's own profile page
      navigate("/profile", { replace: true });
    } else {
      // Continue to the selected user's profile page
      setSearchTerm("");
      setSearchResult(null);
      setErrorMessage("");
    }
  };
  return (
    <div className={searchstyles.mainSearch}>
      <h2>Search User</h2>
      <div className={searchstyles.searchButton}>
        <input
          type="text"
          placeholder="Enter username"
          className={searchstyles.searchInput}
          value={searchTerm}
          onChange={handleInputChange}
        />
        <button className={searchstyles.button3} onClick={handleSearch}>
          <FaMagnifyingGlass />
        </button>
      </div>
      {searchResult ? (
        <Link
          to={`/profile/${searchResult.username}`}
          className={searchstyles.resultLink}
          onClick={handleLinkClick}
        >
          <div className={searchstyles.result}>
            <img
              src={
                searchResult.img_link
                  ? `${apiUrl}/${searchResult.img_link}`
                  : defaultImage
              }
              alt={searchResult.username}
              className={searchstyles.userImage}
            />
            <div className={searchstyles.userInfo}>
              <p className={searchstyles.username}>{searchResult.username}</p>
            </div>
          </div>
        </Link>
      ) : (
        errorMessage && <p className={searchstyles.error}>{errorMessage}</p>
      )}
    </div>
  );
};

export default SearchComp;
